import * as firebase from "firebase/app";
import ResHubLogo from "@/views/login/ResHubLogo.vue";
import { FamilyHubAppStatus } from "@/enums/FamilyHubAppStatus";

export default {
  name: "UnsubscribeFromEmails",
  components: {
    ResHubLogo
  },
  data() {
    return {
      familyMember: null,
      successUnsubscribe: false,
    }
  },
  methods: {
    async unsubscribeFromEmails() {
      await firebase
        .firestore()
        .collection("familyHubUsers")
        .doc(this.familyMember.id)
        .update({
          isUnsubscribedFromEmails: true,
          unsubscribeFromEmailsDateTime: new Date(),
          unsubscribeFromEmailsToken: null,
          invitedToFamilyApp: false,
          appStatus: FamilyHubAppStatus.ReadOnly
        }).finally(() => {
          this.successUnsubscribe = true
        });
    }
  },
  async mounted() {
    await firebase
      .firestore()
      .collection("familyHubUsers")
      .where("unsubscribeFromEmailsToken", "==", this.$route.params.token).get()
      .then((snap) => {
        snap.forEach(doc => {
          this.familyMember = doc.data();
          this.familyMember.id = doc.id
        });
      })
  },
}